import { render, staticRenderFns } from "./TourneesDetailsEdition.vue?vue&type=template&id=d102348a&"
import script from "./TourneesDetailsEdition.vue?vue&type=script&lang=js&"
export * from "./TourneesDetailsEdition.vue?vue&type=script&lang=js&"
import style0 from "./TourneesDetailsEdition.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!E:/projets/dotnet/GestionTournees/dev/GestionTourneesWeb/ClientApp/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VContainer,VFlex,VLayout,VList,VListTile,VListTileTitle,VSubheader})
